<nav class="fixed top-0 bg-gradient-primary h-18 z-30 text-white w-full">
  <!--  <a class="text-xl font-semibold ml-0 md:ml-5" href="">Scholaris</a>-->
  <!--  <button class="md:hidden ml-5 text-white" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"-->
  <!--    aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">-->
  <!--    <span class="text-2xl">☰</span>-->
  <!--  </button>-->
  <div class="mx-auto flex items-center h-full max-w-7xl">
    <a class="hover:text-gray-300 flex items-center gap-3" routerLink="/">
      <img src="assets/scholaris_logo_final.png" alt="Scholaris" class="h-12 w-auto mr-2" />
      <div class="text-4xl font-semibold ruge-boogie-regular -ml-1">Scholaris</div>
    </a>
    <div class="flex ml-16 font-semibold w-full" id="navbarSupportedContent">
      <ul class="flex flex-col md:flex-row">
        <li class="">
          @if (authService.isLoggedIn()) {
            <!--            <a class="text-gray-300 hover:text-white px-3" routerLink="/message" routerLinkActive="active">Message</a>-->
          }
        </li>
      </ul>

      <ul class="flex flex-row items-center gap-2 md:gap-4 mr-auto">
        @if (authService.isLoggedIn()) {
          <a
            class="text-gray-300 hover:text-white px-2"
            routerLink="/projects"
            routerLinkActive="active"
            >Projects</a
          >
          <a
            class="text-gray-300 hover:text-white px-2"
            routerLink="/groups"
            routerLinkActive="active"
            >Groups</a
          >
          @if (canManageUsers()) {
            <a
              class="text-gray-300 hover:text-white px-2"
              routerLink="/admin/users"
              routerLinkActive="active"
              >{{ isSuperAdmin() ? 'System- & User Management' : 'User Management' }}</a
            >
          }
        }
      </ul>
      <ul class="flex flex-row items-center gap-2 md:gap-4 ml-auto">
        @if (!authService.isLoggedIn()) {
          <a
            class="text-gray-300 hover:text-white px-3"
            routerLink="/login"
            routerLinkActive="active"
            >Login</a
          >
          <a
            class="text-gray-300 hover:text-white px-3"
            routerLink="/register"
            routerLinkActive="active"
            >Register</a
          >
        }
        @if (authService.isLoggedIn()) {
          <app-notification-bell></app-notification-bell>
          <a
            class="text-gray-300 hover:text-white px-2"
            routerLink="/"
            (click)="authService.logoutUser()"
            >Logout</a
          >
          <a class="text-gray-300 hover:text-white flex items-center gap-2" routerLink="/profile">
            <span
              class="flex h-11 w-11 items-center justify-center rounded-full bg-gradient-to-br from-secondary to-indigo-600 text-sm font-bold text-white shadow-sm border border-white/10"
            >
              {{ this.getInitials() }}
            </span>
            <!--            <span class="hidden md:inline font-semibold text-gray-200">Profile</span>-->
          </a>
        }
      </ul>
    </div>
  </div>
</nav>
